import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// english
import encommon from "./locales/en/common.json";
import englossary from "./locales/en/glossary.json";
import entermsandconditions from "./locales/en/tnc.json";
import envalidation from "./locales/en/validation.json";
// spanish
import escommon from "./locales/es/common.json";
import esglossary from "./locales/es/glossary.json";
import estermsandconditions from "./locales/es/tnc.json";
import esvalidation from "./locales/es/validation.json";

// sinhala
import sncommon from "./locales/sn/common.json";
import snglossary from "./locales/sn/glossary.json";
import sntermsandconditions from "./locales/sn/tnc.json";
import snvalidation from "./locales/sn/validation.json";

// tamil
import tmlcommon from "./locales/tml/common.json";
import tmlglossary from "./locales/tml/glossary.json";
import tmltermsandconditions from "./locales/tml/tnc.json";
import tmlvalidation from "./locales/tml/validation.json";

const resources = {
  en: {
    common: encommon,
    validation: envalidation,
    glossary: englossary,
    tnc: entermsandconditions,
  },
  es: {
    common: escommon,
    validation: esvalidation,
    glossary: esglossary,
    tnc: estermsandconditions,
  },
  sn: { 
    common: sncommon,
    validation: snvalidation,
    glossary: snglossary,
    tnc: sntermsandconditions,
  },
  tml:{
    common: tmlcommon,
    validation: tmlvalidation,
    glossary: tmlglossary,
    tnc: tmltermsandconditions,
  }
};
// Initialize i18n
i18n
  .use(initReactI18next) // For React integration
  .init({
    resources: resources,

    lng: "en", // Default language
    fallbackLng: "en",
    compatibilityJSON: "v3",
    interpolation: {
      escapeValue: false,
    },
    ns: ["common", "validation", "glossary", "tnc"],
    nsSeparator: ":",
  });

export default i18n;
